<template>
    <div class="participation-info-wrapper">
        <div class="participation-details">
            <h2 class="details-title"> {{ title }} </h2>
            <p class="details-description" v-html="description"/>
        </div>
        <div v-if="buttonText" class="button-wrapper" :class="{'has-warning' : participationWarning}">
            <button class="pastime-button" @click="actionControl(actionType)" :disabled="!enabled"> {{ buttonText }} </button>
            <p v-if="participationWarning" class="participation-warning">
                <i class="ecom-info"/>
<!--                <Popper v-if="participationWarning.popupMsg" position="top"
                        trigger="clickToToggle"
                        id="participationWarningId"
                        class="participation-warning-popup">
                    <i slot="activator" class="ecom-info"/>
                    {{ participationWarning.popupMsg }}
                </Popper>-->
                <span class="warning-msg"> {{ participationWarning.popupMsg ? participationWarning.popupMsg : participationWarning.warningMsg }} </span>
            </p>
        </div>
        <div v-if="secondaryButtonText" class="button-wrapper secondary">
            <button class="pastime-button transparent" @click="actionControl(secondaryActionType)"> {{ secondaryButtonText }} </button>
        </div>
    </div>
</template>

<script>
import {store} from '@/store/pastimes';
import Popper from '@/components/Muffin/Popper';

export default {
    store,
    name: 'ParticipationInfo',
    components: {
        Popper
    },
    props: {
        title: {type: String, default: ''},
        description: {type: String, default: ''},
        buttonText: {type: String, default: ''},
        enabled: {type: Boolean, default: true},
        actionType: {type: String, default: 'modal'}, // modal or link/function etc
        // double action / non modal actions
        secondaryButtonText: {type: String, default: ''},
        secondaryActionType: {type: String, default: 'modal'},
        participationWarning: {type: [Object, String], default: null},
    },
    data() {
        return {};
    },
    computed: {
        // kStrings() {
        //     return this.$store.getters.kStrings;
        // },
    },
    watch: {},
    created() {
    },
    mounted() {
    },
    methods: {
        actionControl(action = 'modal') {
            if(action == 'modal') {
                this.$emit('modal-status', true);
            } else {
                this.$emit(action);
            }
            
        },
    },
};
</script>

<style scoped>

</style>